import axios from 'axios'

export function apiConfig() {
  return axios.create({
    baseURL: process.env.VUE_APP_ANTMEDIA_API_URL,
    withCredentials: false,
    timeout: 5000,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: process.env.VUE_APP_ANTMEDIA_TOKEN,
    },
  })
}

const apiAntmedia = apiConfig()

export { apiAntmedia }
